module.exports = __webpack_public_path__ + "img/content4-10.c1c4bbc7.png";